import { Input } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import type { CompanyDetailsFormValues } from '../CompanyDetails.types';
import { FieldRow } from '../FieldRow';

export const CompanyTypeQuestion = () => {
    const { register } = useFormContext<CompanyDetailsFormValues>();

    return (
        <FieldRow
            htmlFor="companyType"
            label={
                <FormattedMessage
                    id="_.your_company.company_type"
                    defaultMessage="Company type"
                />
            }
        >
            {/* eslint-disable-next-line iwoca/input-a11y */}
            <Input {...register('companyType')} id="companyType" disabled />
        </FieldRow>
    );
};
